const LockIcon = (props) => {
    return <i className={"fa-solid fa-lock " + props.className}></i>
}

export default LockIcon;